import React from 'react';
import { useNavigate } from 'react-router-dom';
import CreateClaim from './CreateClaim';
import CreateClaimRecord from './CreateClaimRecord';

// Pestaña "Nuevo reclamo": solo el formulario del reclamo. Al guardar se abre
// la ficha, donde sigue el flujo de pasos (los cheques y el cobro de la
// comisión de CSR se trabajan dentro del reclamo, en la Fase 4).
// duplicateFrom: duplicar un reclamo del modelo anterior (CreateClaim).
const QuickCreate = ({ onClaimCreated, duplicateFrom, onDuplicateConsumed }) => {
  const navigate = useNavigate();

  if (duplicateFrom) {
    return <CreateClaim onClaimCreated={onClaimCreated} duplicateFrom={duplicateFrom} onDuplicateConsumed={onDuplicateConsumed} />;
  }

  return <CreateClaimRecord existingRecord={null} onCreated={record => navigate(`/claim-status/claim/${record.id}`)} />;
};

export default QuickCreate;
